// extracted by mini-css-extract-plugin
export default {"user-table":"User_user-table__hUU2k","user-table__action":"User_user-table__action__v0-Hb","user-table__action--button":"User_user-table__action--button__GYT9I"};